/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

import 'url-search-params-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueLogger from 'vuejs-logger';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import VueCarousel from 'vue-carousel';
import Tabs from 'vue-tabs-component';
import includes from 'lodash.includes';
import videoPlayer from 'vue-videojs-player-v7';
import fullscreen from 'vue-fullscreen';
import VueDragscroll from 'vue-dragscroll';
import 'reset-css/reset.css';
// eslint-disable-next-line
import 'video.js/dist/video-js.css';
import 'animate.css/animate.css';
import VueLocalStorage from 'vue-ls';
import Meta from 'vue-meta';
import './assets/scss/skins/alive/style.scss';
import VueCountdownTimer from 'vuejs-countdown-timer';
import Vue2TouchEvents from 'vue2-touch-events';
import App from './App.vue';
import router from './router';
import protoStore from './store';
import messages from './assets/i18n/i18n';

Vue.use(Vue2TouchEvents);
Vue.use(VueCountdownTimer);

const isProduction = process.env.NODE_ENV === 'production';
const env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev';

const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};
Vue.use(Meta);
Vue.use(VueLogger, loggerOptions);
Vue.use(VueDragscroll);

const conf = require('../public/conf.json');
let locale = conf.locale ? conf.locale : navigator.language.split('-')[0];
if (!includes(conf.locales, locale)) {
  locale = 'en';
}

Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.use(VueI18n);
Vue.use(VueCarousel);
Vue.use(fullscreen);
Vue.use(Tabs);
Vue.use(videoPlayer);
window.TOK_NS = 'alive__';
const options = {
  namespace: window.TOK_NS,
};

Vue.use(VueLocalStorage, options);

Vue.mixin({
  computed: {
    ...Vuex.mapState(['appName', 'logo', 'widgetMode', 'md', 'env', 'conf']),
    ...Vuex.mapGetters(['isWidget']),
  },
  methods: {
    getCookie(name) {
      const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
      const cookie = v ? v[2] : null;
      return JSON.parse(cookie);
    },
    isStoreValid(ls) {
      const now = new Date().getTime();
      const difference = (now - ls.time) / 1000;
      return !(ls && ls.data && difference > 60);
    },
  },
});

const urlParams = new URLSearchParams(window.location.search);
window.vpQueryLocale = urlParams.get('locale');
if (window.vpQueryLocale) locale = window.vpQueryLocale;

const i18n = new VueI18n({
  locale,
  messages,
});
window.app = new Vue({
  router,
  store: protoStore(conf, env, locale),
  i18n,
  render: h => h(App),
}).$mount('#app');
